var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartyMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 1.24399V1.19699C23.9653 0.851318 23.7536 0.548462 23.441 0.397003C23.0912 0.227844 22.6752 0.276611 22.374 0.522003C19.5034 2.84729 18.5023 2.30127 16.8558 1.40317L16.85 1.39999C13.8845 -0.461334 10.1154 -0.461334 7.14999 1.39999L7.13754 1.40677C5.48898 2.30273 4.4928 2.84415 1.63199 0.514984C1.33136 0.269806 0.916077 0.220581 0.566467 0.388763C0.216888 0.556915 -0.00390625 0.912079 0 1.29999C0.0350037 3.78101 0.694 11.863 7.694 11.863C9.16867 11.8775 10.6312 11.5945 11.994 11.031C13.3613 11.5935 14.8275 11.8764 16.306 11.863C18.33 11.9421 20.2739 11.0673 21.557 9.5C21.6236 9.41907 21.7336 9.38828 21.8326 9.42288C21.9315 9.45752 21.9984 9.55017 22 9.655V23C22 23.5523 22.4477 24 23 24C23.5523 24 24 23.5523 24 23V1.29999V1.24399ZM10.558 7.466C10.158 8.436 8.77698 8.785 7.474 8.24698C6.22919 7.44992 5.11588 6.46417 4.17398 5.32498C4.03677 5.18198 3.99701 4.97141 4.0726 4.78818C4.14816 4.60495 4.32486 4.48367 4.52298 4.479C5.99417 4.33649 7.47855 4.42352 8.92297 4.737C10.225 5.27499 10.958 6.5 10.558 7.466ZM16.578 8.24698C17.8228 7.44992 18.9361 6.46414 19.878 5.32498C20.0152 5.18195 20.055 4.97137 19.9794 4.78818C19.9038 4.60495 19.7271 4.48367 19.529 4.47897C18.0578 4.33652 16.5735 4.42355 15.129 4.73697C13.826 5.27499 13.094 6.49597 13.494 7.46597C13.894 8.43597 15.278 8.78497 16.578 8.24698Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyMask);
export default __webpack_public_path__ + "static/media/partyMask.017e5a01.svg";
export { ForwardRef as ReactComponent };